import axios from "@/utils/axios.js";

// 获取用户主页会员订单(会员订单)
export function getUserVipOrder(params) {
  return axios({
    url: "/member/orderList",
    method: "get",
    params
  });
}

// 用户主页会员订单(我已支付)
export function myPayment(data) {
  return axios({
    url: "/member/paidOrder",
    method: "post",
    data
  });
}

// 图片订单详情
export function getPhotoOrderDetails(params) {
  return axios({
    url: `/api/commodityPhoto/details`,
    method: "get",
    params
  });
}

// 视频订单详情
export function getVideoOrderDetails(params) {
  return axios({
    url: `/api/commodityVideo/details`,
    method: "get",
    params
  });
}

// 用户主页会员订单(取消订单)
export function cancelOrder(data) {
  return axios({
    url: "/member/cancelOrder",
    method: "post",
    data
  });
}

// 获取用户主页我的订单图片列表
export function getPhotoOrderList(params) {
  return axios({
    url: "/api/commodityPhoto/orderList",
    method: "get",
    params
  });
}

//用户主页我的订单图片订单取消
export function photoCancel(data) {
  return axios({
    url: `/api/comomdityPhoto/cancel?orderId=${data}`,
    method: "post",
    data
  });
}

//用户主页我的订单图片立即支付
export function photoPay(data) {
  return axios({
    url: "/api/commodityPhoto/pay",
    method: "post",
    data
  });
}

//用户主页我的订单图片删除
export function PhotoOrderDelete(data) {
  return axios({
    url: "/api/comomdityPhoto/deleteOrder",
    method: "post",
    data
  });
}

// 获取用户主页我的订单图片列表
export function getVideoOrderList(params) {
  return axios({
    url: "/api/commodityVideo/orderList",
    method: "get",
    params
  });
}

// 获取用户主页我的发票列表
export function getInvoiceOrderList(params) {
  return axios({
    url: "/invoice/userPageList",
    method: "get",
    params
  });
}

// 获取用户主页我的发票详情
export function getInvoiceDetail(params) {
  return axios({
    url: `/invoice/detailid`,
    method: "get",
    params
  });
}

// 获取用户主页发票订单列表（对话框）
export function getInvoiceOrderPageList(params) {
  return axios({
    url: `/invoice/orderPageList`,
    method: "get",
    params
  });
}

// 申请发票（新增）
export function addInvoice(data) {
  return axios({
    url: `/invoice/add`,
    method: "post",
    data
  });
}

// 获取用户主页我的套餐
export function getUserMyMeal(params) {
  return axios({
    url: "/member/combo",
    method: "get",
    params
  });
}

// 获取用户主页下载记录（图片）
export function getUserdownloadListPhoto(params) {
  return axios({
    url: "/api/photo/downloadList",
    method: "get",
    params
  });
}

// 获取用户主页下载记录（视频）
export function getUserownloadListVideo(params) {
  return axios({
    url: "/api/video/downloadList",
    method: "get",
    params
  });
}

// 影像馆主页推荐置列表
export function getImageMuseumRecommendlist(params) {
  return axios({
    url: "/imageMuseum/recommendList",
    method: "get",
    params
  });
}

// 影像馆主页推荐排序
export function imageMuseumUpdateSort(data) {
  return axios({
    url: "/imageMuseum/updateSort",
    method: "post",
    data
  });
}

// 影像馆主页推荐添加和编辑
export function imageMuseumaddOrUpdateSet(data) {
  return axios({
    url: "/imageMuseum/addOrUpdateSet",
    method: "post",
    data
  });
}

// 影像馆主页推荐删除
export function imageMuseumDel(params) {
  return axios({
    url: "/imageMuseum/deleteSet",
    method: "DELETE",
    params
  });
}

// 根据点位获取景点（地址切换组件）
export function lookAreaCountList(params) {
  return axios({
    url: "/userHomepage/lookAreaCountList",
    method: "get",
    params
  });
}

//更换头像
export function updateheadImage(data) {
  return axios({
    url: `//user/updateHeadImage?headImage=${data.headImage}`,
    method: "post",
    data
  });
}

//修改用户名
export function updateUsername(data) {
  return axios({
    url: `/user/updateUsername?username=${data.username}`,
    method: "post",
    data
  });
}

//修改密码
export function updatePassword(data) {
  return axios({
    url: `/user/updatePassword?password=${data.password}&newPassword=${
      data.newPassword
    }`,
    method: "post",
    data
  });
}

//修改绑定手机号
export function updateTelphone(data) {
  return axios({
    url: `/user/updateTelphone?telphone=${data.telphone}&newTelphone=${
      data.newTelphone
    }&code=${data.code}`,
    method: "post",
    data
  });
}

// 修改摄影师信息
export function updatePhotographerInfo(data) {
  return axios({
    url: `/user/updatePhotographerInfo?location=${data.location}&specialties=${
      data.specialties
    }&field=${data.field}`,
    method: "post",
    data
  });
}

// 修改影像馆信息
export function updateImageMuseumInfo(data) {
  return axios({
    url: `/user/updateImageMuseumInfo?region=${data.region}&regionLevel=${
      data.regionLevel
    }&cover=${data.cover}`,
    method: "post",
    data
  });
}

// 影像馆添加展示图
export function addShowPhoto(data) {
  return axios({
    url: `/user/addShowPhoto?photoId=${data.photoId}`,
    method: "post",
    data
  });
}

// 影像馆删除展示图
export function delShowPhoto(data) {
  return axios({
    url: `/user/deleteShowPhoto?photoId=${data.photoId}`,
    method: "DELETE",
    data
  });
}

//专辑列表
export function abumList(params) {
  return axios({
    url: "/album/list",
    method: "get",
    params
  });
}

//新增专辑
export function abumAdd(data) {
  return axios({
    url: `/album/add?name=${data.name}`,
    method: "post",
    data
  });
}

//专辑重命名
export function abumRename(data) {
  return axios({
    url: `/album/rename?id=${data.id}&name=${data.name}`,
    method: "post",
    data
  });
}

//专辑设置封面
export function abumSetCover(data) {
  return axios({
    url: `/album/setCover`,
    method: "post",
    data
  });
}

//排序专辑
export function abumUpdateSort(data) {
  return axios({
    url: `/album/updateSort?id=${data.id}&sort=${data.sort}`,
    method: "post",
    data
  });
}

//删除专辑
export function deletAebum(data) {
  return axios({
    url: `/album/delete?id=${data.id}`,
    method: "delete",
    data
  });
}

// 专辑素材列表
export function abumConList(params) {
  return axios({
    url: "/album/material/pageList",
    method: "get",
    params
  });
}

// 专辑批量添加素材

export function abumAddMaterial(data) {
  console.log(data);
  return axios({
    url: `/album/material/batchAdd?albumId=${data[0].albumId}`,
    method: "post",
    data
  });
}

//查询符合素材
export function albumSearch(params) {
  return axios({
    url: "/album/search/list",
    method: "get",
    params
  });
}

//专辑素材批量删除
export function albumDelMaterial(data) {
  console.log(data);
  return axios({
    url: `/album/material/batchDelete?ids=${data.ids}&albumId=${data.albumId}`,
    method: "delete",
    data
  });
}

//设置封面
export function albumSetCover(data) {
  // console.log(data);
  return axios({
    url: `/album/setCover?id=${data.id}&coverUrl=${data.coverUrl}`,
    method: "post",
    data
  });
}

// 专辑素材调整位置
export function albumMaterialUpdateSort(data) {
  // console.log(data);
  return axios({
    url: `/album/material/updateSort?id=${data.id}&sort=${data.sort}`,
    method: "post",
    data
  });
}

// 专辑素材置顶
// export function albumMaterialtop(data) {
//   // console.log(data);
//   return axios({
//     url: `/album/material/top?id=${data.id}&albumId=${data.albumId}`,
//     method: "post",
//     data
//   });
// }



//////////////////
// WEBPACK FOOTER
// ./src/api/userHome.js
// module id = ggP3
// module chunks = 41